export default __webpack_public_path__ + "static/media/NiftyCats.bd0a917a.gif";